
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiComPa as ObiComPaElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-com-pa.js';
 
 
 

 
 export const ObiComPa = createComponent({
   react: React,
   tagName: 'obi-com-pa',
   elementClass: ObiComPaElement,
   events: {
     
   }
  });
 
 